import React from "react";

export function LogoSmall(props: React.ComponentProps<"svg">) {
  return (
    <svg
      width="44"
      height="32"
      viewBox="0 0 44 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_498_974)">
        <path
          d="M43.8354 14.9071V23.5723C43.8354 24.4485 43.132 25.1567 42.2943 25.1567C41.4564 25.1567 40.7533 24.4485 40.7533 23.5723V15.4818C40.7533 13.2221 39.4812 12.4484 38.0074 12.4484C36.6336 12.4484 35.3615 13.3247 34.5584 14.8086V14.9092V23.5742C34.5584 24.4507 33.8551 25.1587 33.052 25.1587C32.1814 25.1587 31.4783 24.4507 31.4783 23.5742V15.4838C31.4783 13.2242 30.2062 12.4504 28.7325 12.4504C27.3587 12.4504 26.0865 13.3617 25.2835 14.8435V23.5764C25.2835 24.4527 24.6128 25.1606 23.7424 25.1606C22.9045 25.1606 22.2012 24.4527 22.2012 23.5764V11.4735C22.2012 10.5972 22.9045 9.88908 23.7424 9.88908C24.6128 9.88908 25.2835 10.5972 25.2835 11.4735V11.8778C26.423 10.4288 27.8275 9.61817 29.6701 9.61817C31.4783 9.61817 33.1517 10.4945 33.9897 12.2144C35.2962 10.4945 36.9025 9.61817 38.8778 9.61817C41.491 9.61407 43.8354 11.3668 43.8354 14.9071Z"
          fill="#312658"
        />
        <path
          d="M9.30144 31.8781C9.16079 31.8781 9.02012 31.8595 8.87744 31.8227C8.00702 31.5886 7.49129 30.6876 7.72368 29.8113L15.3332 1.21773C15.5656 0.34137 16.4605 -0.177879 17.3309 0.0560912C18.2013 0.29006 18.717 1.19105 18.4847 2.06741L10.8751 30.661C10.6815 31.3938 10.021 31.8781 9.30144 31.8781Z"
          fill="#F55151"
        />
        <path
          d="M1.63347 31.8781C1.49282 31.8781 1.35217 31.8595 1.20948 31.8227C0.339055 31.5886 -0.176673 30.6876 0.0557108 29.8113L7.66525 1.21773C7.89764 0.34137 8.79253 -0.177879 9.66295 0.0560912C10.5333 0.29006 11.0491 1.19105 10.8167 2.06741L3.20717 30.661C3.0135 31.3938 2.35305 31.8781 1.63347 31.8781Z"
          fill="#F55151"
        />
      </g>
      <defs>
        <clipPath id="clip0_498_974">
          <rect width="43.8356" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
